
import { Component, OnInit, ViewChild } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { IonContent, NavParams, Platform } from "@ionic/angular";
import { fromEvent, Subscription } from "rxjs";
import { Navigator } from "src/app/components/menu/navigator";
import { BannerService } from "src/app/services/banner/banner.service";
import { CashierService } from "src/app/services/cashier/cashier.service";
import { DepositService } from "src/app/services/cashier/deposit.service";
import { isUndefined } from "src/app/services/codeUtils";
import { ConfigService } from "src/app/services/config/config.service";
import { EventsService } from "src/app/services/event/event.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { CashierBase } from "../../cashier-base/cashier-base";
import { AffiliateTrackerCallbackParams } from "src/app/interfaces/affliation-interface";

@Component({
  selector: "page-deposit-instadebit",
  templateUrl: "deposit-instadebit-action.html",
})
export class DepositInstaDebitActionPage
  extends CashierBase
  implements OnInit
{
  @ViewChild("Content") content: IonContent;

  private amount: number;
  private bonusID: string;
  private bonusCode: string;
  private paymentRequestID;
  private iframe_url;

  public isMobile;

  public check_deposit_complete: boolean = false;
  public check_deposit_result: string;
  public loading: boolean = true;
  public instadebitCallBack: Subscription;

  constructor(
    public platform: Platform,
    private sanitizer: DomSanitizer,
    private config: ConfigService,
    private navigator:Navigator,

    protected userSessionProvider: UserSessionService,

    protected navParams: NavParams,
    protected utils: UtilsService,
    private cashierProvider: CashierService,
    protected events: EventsService,
    protected bannerProvider: BannerService,
    private depositService:DepositService

  ) {
    super();

    this.amount = this.navParams.get("amount");
    this.paymentRequestID = this.navParams.get("paymentRequestID");
    this.bonusCode = this.navParams.get("bonusCode");
    this.bonusID = this.navParams.get("bonusID");

    this.instadebitCallBack = fromEvent(window, 'message').subscribe((event: any) => {
      if (event.data.id) {
          this.checkDeposit(event.data.id);
          this.unsubscribe();
      }
  });   
  }

  ngOnInit() {
    this.userSessionProvider.getCustomer().subscribe((customer) => {
      let params = {
        merchant_id: this.config.getConfig().INSTADEBIT_MERCHANT_ID,
        merchant_user_id: customer.customerId,
        txn_currency: this.config.getConfig().DEFAULT_CURRENCY,
        merchant_txn_num: this.paymentRequestID,
        txn_amount: this.amount,
        merchant_sub_id: this.config.getConfig().INSTADEBIT_MERCHANT_SUB_ID,
        return_url: encodeURIComponent(
          `${
            this.config.getConfig().LOBBY_URL
          }/assets/static/deposit_script.html?paymentRequestID=${
            this.paymentRequestID
          }#instadebit-return`
        ),
      };

      let queryString = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      this.iframe_url = this.sanitizer.bypassSecurityTrustResourceUrl(
        `${
          this.config.getConfig().WEBSERVICES_URL
        }/external/instadebit-post?${queryString}`
      );
    });
  }

  loadiFrame() {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  checkDeposit(paymentRequestId) {
    if (!isUndefined(paymentRequestId)) {
        this.depositService.checkDepositStatus(paymentRequestId).subscribe(
            (response) => {
                this.check_deposit_complete = true;
                console.log(response);
                if (!isUndefined(response.payload)) {
                    switch(response.payload.status) {
                      case 'APPROVED':
                        /*let depositEventData: AffiliateTrackerCallbackParams = {
                          customer_id: this.cashierProvider.customer.customerId,
                          amount: this.amount,
                          paymentMethod: "INSTADEBIT"
                        }
                        setTimeout(() => this.events.publish('event:deposit', depositEventData), 2000);*/
                        this.navigator.navigateTo(
                          "DepositSuccessFailureComponent",
                          {},
                          { status: true}
                        );
                        break;
                      case 'IN PROCESS':
                        this.navigator.navigateTo(
                          "DepositSuccessFailureComponent",
                          {},
                          {
                            status: false,
                            message:
                              "Your deposit transaction is still in progress.<br/>Please check your account or contact customer support.",
                          }
                        );
                        break;
                      case 'CANCELLED':
                        this.navigator.navigateTo(
                          "DepositSuccessFailureComponent",
                          {},
                          {
                            status: false, 
                            message:
                              "Your deposit transaction did not succeed.",
                          }
                        );
                        break;
                      default:
                        this.navigator.navigateTo(
                          "DepositSuccessFailureComponent",
                          {},
                          {
                            status: false, 
                            message:
                              "Your deposit transaction could not be processed.",
                          }
                        );
                        break;
                    }
                } else {
                    //this.check_deposit_result = 'FAIL'
                    this.navigator.navigateTo(
                      "DepositSuccessFailureComponent",
                      {},
                      { status: false }
                    );
                }
            },
            (error) => {
                //this.check_deposit_complete = true;
                //this.check_deposit_result = 'FAIL'
                this.navigator.navigateTo(
                  "DepositSuccessFailureComponent",
                  {},
                  { status: false }
                );
            }
        );
    } else {
        //this.check_deposit_complete = true;
        //this.check_deposit_result = 'FAIL'
        this.navigator.navigateTo(
          "DepositSuccessFailureComponent",
          {},
          { status: false }
        );
    }
}

closeDialog() {
    this.navigator.toLobby();
}

onBack = () => {
    if (!!this.navParams.get("navigateBackPage")) {
        let navigateBackPage = this.navParams.get("navigateBackPage");
        this.navigator.navigateTo(navigateBackPage);
    } else {
        this.navigator.back();
    }
}

unsubscribe(){
  this.instadebitCallBack.unsubscribe();
}
}
